export default {"src":"/_next/static/media/paint-car.45bcfd1e.gif","height":651,"width":1278};